import { Modal } from '@mui/material';
import React, { FC, PropsWithChildren } from 'react';

import * as Styled from './styled';

type Props = PropsWithChildren & {
  isActive?: boolean;
  onClose?: () => void;
  requestClear: () => void;
};

/**
 * Label create modal component
 *
 * @param props              Props passed to the component
 * @param props.children     The children to render inside the modal
 * @param props.isActive     Whether the modal should be visible
 * @param props.onClose      Callback to close the modal
 * @param props.requestClear Callback to clear the form
 * @returns                  The component itself
 */
const LabelCreateModal: FC<Props> = ({
  children,
  isActive = false,
  onClose,
  requestClear,
}) => {
  /**
   * Request to close the modal
   */
  const requestClose = () => {
    requestClear();
    onClose?.();
  };

  return (
    <Modal
      onClose={requestClose}
      open={isActive}
      slotProps={{
        root: {
          style: Styled.WrapperRootStyles,
        },
      }}
    >
      <Styled.ContentWrapper>{children}</Styled.ContentWrapper>
    </Modal>
  );
};

export default LabelCreateModal;
